export const iconName = value => {
  return value.includes('users')
    ? 'allContacts'
    : value.includes('groups')
    ? 'group'
    : value.includes('Urls') || value.includes('domains')
    ? 'globe'
    : value.includes('addresses')
    ? 'http'
    : 'connect';
};
